module.exports = __webpack_public_path__ + "static/img/jc-1.49eabe80.webp";